/**
 * Animal species group an activity's PŠGP fields refer to. Fixed by regulation, so it has no
 * classifier table: the backend mirrors the same `int` values on the activity record.
 */
export enum SgpAnimalSpecies {
	NonRuminants = 1,
	Poultry = 2,
	Pigs = 3,
	AquacultureAnimals = 4,
	FarmedInsects = 5,
}

/** The species a complete feed can be intended for — farmed insects are only ever a source of protein. */
type SgpFeedAnimal = Exclude<SgpAnimalSpecies, SgpAnimalSpecies.FarmedInsects>;

/** The species processed protein can be obtained from. */
type SgpProteinSourceAnimal = Exclude<SgpAnimalSpecies, SgpAnimalSpecies.AquacultureAnimals>;

export const sgpFeedTargets: SgpAnimalSpecies[] = [
	SgpAnimalSpecies.NonRuminants,
	SgpAnimalSpecies.Poultry,
	SgpAnimalSpecies.Pigs,
	SgpAnimalSpecies.AquacultureAnimals,
] satisfies SgpFeedAnimal[];

export const sgpProteinSources: SgpAnimalSpecies[] = [
	SgpAnimalSpecies.NonRuminants,
	SgpAnimalSpecies.Poultry,
	SgpAnimalSpecies.Pigs,
	SgpAnimalSpecies.FarmedInsects,
] satisfies SgpProteinSourceAnimal[];
